import React from 'react';
import { object, node } from 'prop-types';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';

import VisualTag from '../product-detail/VisualTag';
import VisualHighlight from '../product-detail/VisualHighlight';
import VerifiedHighlight from '../product-detail/VerifiedHighlight';


const Container = styled.div`
  margin: 16px 16px 64px 16px;
`;

const Header = styled.div`
  display: flex;
  justify-content: center;
  /* margin: 0 -15px; */
  align-items: center;
`;

const TextBox = styled.div`
  width: 496px;
  margin-right: 32px;
`;

const Img = styled.img`
  width: 380px;
  height: 316px;
  margin-left: 32px;
  object-fit: contain;
`;

const Title = styled(ReactMarkdown)`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
  color: #4a4a4a;
`;

const Description = styled(ReactMarkdown)`
  * {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: #999999;
    margin-top: 8px;
  }

  strong {
    font-weight: bold;
  }
  a {
    color: #6E0AD6;
    font-weight: 700;
  }
`;

const transformToBold = text => text.replace(/"/g, '**');

const Paragraph = ({ children }) => (
  <p style={{ display: 'inline' }}>{children}</p>
);

const BenefitItemStacked = ({ benefit }) => {
  const defaultRenderer = { paragraph: Paragraph };
  const isVehicleHistoryBenefit = benefit.id === 'vehicleHistory';
  const colorHighlightBadgeBoost = benefit.id === 'highlightBadgeBoost' ? '#F28000' : '#6e0ad6';
  const renderers = {
    ...defaultRenderer,
    strong: props => (isVehicleHistoryBenefit ? <VerifiedHighlight {...props} /> : <VisualHighlight {...props} color={colorHighlightBadgeBoost} />),
    emphasis: props => <VisualTag {...props} />,
  };
  return (
    <Container id={benefit.id}>
      <Header>
        <TextBox>
          <Title renderers={renderers}>{transformToBold(benefit.title)}</Title>
          <Description>{benefit.text}</Description>
        </TextBox>
        <Img src={benefit.image} alt={benefit.title} />
      </Header>
    </Container>
  );
};

export default BenefitItemStacked;

BenefitItemStacked.propTypes = {
  benefit: object.isRequired,
};

Paragraph.propTypes = {
  children: node.isRequired,
};
